var regex = /left|center|right/;
export default function isHorizontalAttachment(attachment) {
  return typeof attachment === 'string' && regex.test(attachment);
}